import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import CircleStyle from 'ol/src/style/Circle';
import { Stroke, Style, Fill } from 'ol/style';
import { OSM } from 'ol/source';
import Overlay from 'ol/Overlay';
import { toStringHDMS } from 'ol/coordinate';
import { toLonLat } from 'ol/proj';
@Component({
  selector: 'lib-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, OnChanges {
  constructor() {}
  map: Map;

  @Input()
  geojson: GeoJSON | undefined;

  @Input()
  clearMap: boolean;

  ngOnInit(): void {
    this.initilizeMap();
  }

  ngOnChanges(simpleChange: SimpleChanges): void {
    this.addVectorDataLayer(simpleChange);

    this.clearMapData(simpleChange);
  }

  initilizeMap() {
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    const closer = document.getElementById('popup-closer');
    const overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    this.map = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      overlays: [overlay],
      view: new View({
        projection: 'EPSG:4326',
        center: [0, 0],
        zoom: 7,
      }),
    });

    const buildPopup = (feature) => {
      let showPopup = '';
      feature.forEach((element) => {
        for (const p in element.getProperties()) {
          if (p !== 'geometry') {
            showPopup += `<p> ${p} -: ${element.getProperties()[p]} </p>`;
          }
        }
      });

      return showPopup;
    };
    // pointermove
    this.map.on('click', (evt: any) => {
      const coordinate = evt.coordinate;
      const hdms = toStringHDMS(toLonLat(coordinate));
      const f: any = this.map.getFeaturesAtPixel(evt.pixel);
      content.innerHTML = buildPopup(f);
      overlay.setPosition(coordinate);
    });

    closer.onclick = () => {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };
  }

  addVectorDataLayer(simpleChange: SimpleChanges) {
    if (simpleChange.geojson && this.map !== undefined) {
      const featureCollection: GeoJSON = simpleChange.geojson.currentValue;
      const image = new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: 'rgb(4, 11, 70)',
        }),
        stroke: new Stroke({ color: '#FF9C32', width: 2 }),
      });

      const styles = {
        Point: new Style({
          image,
        }),
        LineString: new Style({
          stroke: new Stroke({
            color: 'green',
            width: 1,
          }),
        }),
        MultiLineString: new Style({
          stroke: new Stroke({
            color: 'green',
            width: 1,
          }),
        }),
        MultiPoint: new Style({
          image,
        }),
        MultiPolygon: new Style({
          stroke: new Stroke({
            color: 'yellow',
            width: 1,
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 0, 0.1)',
          }),
        }),
        Polygon: new Style({
          stroke: new Stroke({
            color: 'blue',
            lineDash: [4],
            width: 3,
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
          }),
        }),
        GeometryCollection: new Style({
          stroke: new Stroke({
            color: 'magenta',
            width: 2,
          }),
          fill: new Fill({
            color: 'magenta',
          }),
          image: new CircleStyle({
            radius: 10,
            fill: null,
            stroke: new Stroke({
              color: 'magenta',
            }),
          }),
        }),
        Circle: new Style({
          stroke: new Stroke({
            color: 'red',
            width: 2,
          }),
          fill: new Fill({
            color: 'rgba(255,0,0,0.2)',
          }),
        }),
      };
      const styleFunction = (feature) => {
        return styles[feature.getGeometry().getType()];
      };
      const vectorSource = new VectorSource({
        features: [],
      });
      vectorSource.clear();
      if (featureCollection) {
        vectorSource.addFeatures(new GeoJSON().readFeatures(featureCollection));
        const vectorLayer = new VectorLayer({
          source: vectorSource,
          style: styleFunction,
        });
        if (this.map.getLayers().getLength() === 2) {
          this.map.getLayers().getArray().pop();
        }
        this.map.addLayer(vectorLayer);
        this.map.getView().fit(vectorSource.getExtent());
      }
    }
  }

  clearMapData(simpleChange: SimpleChanges) {
    if (simpleChange.clearMap.currentValue) {
      this.map
        .getLayers()
        .getArray()
        .forEach((element: VectorLayer) => {
          element.getSource().clear();
        });
      console.log(' clear map ', simpleChange.clearMap.currentValue);
    }
  }
}
